export default "__VITE_ASSET__3JYbQDFO__"